import { useEffect, useState } from "react";
import API from "../../../services/api";
import { createCourse } from "../../../services/courseApi";
import { useNavigate } from "react-router-dom";
import "./AddCareerCourse.css";

export default function AddCareerCourse() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);

  const [form, setForm] = useState({
    name: "",
    class_id: "",
    eligibility: "",
    entrance_exam: "",
    colleges: [{ name: "", website: "" }],
  });

  const loadClasses = async () => {
    try {
      const res = await API.get("/school-admin/classes/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setClasses(res.data.classes || []);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadClasses(); }, []);

  const addCollege = () =>
    setForm({ ...form, colleges: [...form.colleges, { name: "", website: "" }] });

  const removeCollege = (i) =>
    setForm({ ...form, colleges: form.colleges.filter((_, idx) => idx !== i) });

  const updateCollege = (i, field, value) => {
    const updated = [...form.colleges];
    updated[i][field] = value;
    setForm({ ...form, colleges: updated });
  };

  const handleSubmit = async () => {
    if (!form.name || !form.class_id) return alert("Course name and class are required");
    try {
      setLoading(true);
      await createCourse(form);
      alert("Course added!");
      navigate("/school-admin/career");
    } catch { alert("Failed to add course"); }
    finally { setLoading(false); }
  };

  return (
    <div className="acc-page">

      {/* ══ HERO ══ */}
      <div className="acc-hero">
        <div className="acc-hero-left">
          <span className="acc-hero-icon">🎓</span>
          <div>
            <h2 className="acc-hero-title">Add Career Course</h2>
            <p className="acc-hero-sub">Help students discover the right career path</p>
          </div>
        </div>
        <a href="/school-admin/career" className="acc-btn-back">← Back</a>
      </div>

      {/* ══ COURSE DETAILS ══ */}
      <div className="acc-card">
        <p className="acc-card-title">Course Details</p>

        <div className="acc-grid-2">
          <div className="acc-field">
            <label>Course Name *</label>
            <input
              placeholder="e.g. Engineering, Medicine, Law"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
            />
          </div>

          <div className="acc-field">
            <label>Target Class *</label>
            <select
              value={form.class_id}
              onChange={e => setForm({ ...form, class_id: e.target.value })}
            >
              <option value="">— Select Class —</option>
              {classes.map(c => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
          </div>

          <div className="acc-field">
            <label>Entrance Exam</label>
            <input
              placeholder="e.g. JEE, NEET, CLAT"
              value={form.entrance_exam}
              onChange={e => setForm({ ...form, entrance_exam: e.target.value })}
            />
          </div>
        </div>

        <div className="acc-grid-1 acc-field">
          <label>Eligibility Criteria</label>
          <textarea
            placeholder="e.g. 10+2 with Physics, Chemistry, Maths — minimum 60%"
            value={form.eligibility}
            onChange={e => setForm({ ...form, eligibility: e.target.value })}
          />
        </div>
      </div>

      {/* ══ COLLEGES ══ */}
      <div className="acc-card">
        <p className="acc-card-title">
          Colleges &amp; Institutions — {form.colleges.length} added
        </p>

        {form.colleges.map((col, i) => (
          <div key={i} className="acc-college-row">
            <div>
              <span className="acc-college-num">College {i + 1}</span>
              <input
                placeholder="College / Institution name"
                value={col.name}
                onChange={e => updateCollege(i, "name", e.target.value)}
              />
            </div>
            <div>
              <span className="acc-college-num">Website</span>
              <input
                placeholder="https://..."
                value={col.website}
                onChange={e => updateCollege(i, "website", e.target.value)}
              />
            </div>
            {form.colleges.length > 1 && (
              <button
                className="acc-btn-remove-college"
                onClick={() => removeCollege(i)}
                title="Remove"
              >
                ✕
              </button>
            )}
          </div>
        ))}

        <button className="acc-btn-add-college" onClick={addCollege}>
          + Add Another College
        </button>
      </div>

      {/* ══ SUBMIT ══ */}
      <div className="acc-card">
        <button
          className="acc-btn-submit"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading
            ? <><div className="acc-spinner"></div> Saving…</>
            : "✓ Save Course"
          }
        </button>
      </div>

    </div>
  );
}
